import "./Footer.scss";

export default function Footer() {
  return (
    <div className="footer">
      <h6>© 2020 MaccaVanPhuc - Developed by Aliénor Thuy Nguyen</h6>
    </div>
  );
}
